import { useStoreState } from 'pullstate';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FooterData, INavLink } from '../../global';
import DslStore, {  setNavLinkActive } from '../../store/DslStore';
import { getAllMenus, getFooterMenuSelected } from '../../store/Selectors';
import styles from './PageNavigation.module.scss';
import { red } from '@mui/material/colors';

interface Props {
  links: FooterData[];
  bgColor?: string;
}

const PageNav = ({ links }: { links: INavLink[] }) => {
  // const activePage = useStoreState(DslStore, getNavLinkActive);
  const activeFooter = useStoreState(DslStore, getFooterMenuSelected);
  const menus = useStoreState(DslStore, getAllMenus);
  const location = useLocation();
  const pathName = location.pathname;
  const [searchedItem, setSearchedItem] = useState<FooterData>({ id: 0, text: '', path: '' });
  const redirect = useNavigate();
  function findPage() {
    let pathLength = pathName.split('/').length - 1;
    if (pathLength === 2) {
      let path = '/' + pathName.split('/')[2];
      menus.map((item: any) => item.data.map((item: FooterData) => (item.path === path ? setSearchedItem(item) : null)));
    } else if (pathLength === 3) {
      let path = '/' + pathName.split('/')[3];
      menus.map((item: any) => item.data.map((item: FooterData) => (item.path === path ? setSearchedItem(item) : null)));
    } else if (pathLength === 4) {
      let path = '/' + pathName.split('/')[4];
      menus.map((item: any) => item.data.map((item: FooterData) => (item.path === path ? setSearchedItem(item) : null)));
    }

    // menus.map((item: any) => item.data.map((item: FooterData) => (item.path === path ? setSearchedItem(item) : null)));
  }

  useEffect(() => {
    // console.log(pathName.split('/')[2]);
    // console.log(activePage);
    findPage();

    links.map((navlink) => (navlink.path === pathName ? setNavLinkActive(navlink) : null));
    return () => {};
  });

  const changePage = (navLink: FooterData) => {
    // setNavLinkActive(navLink);
    console.log('changePage');
    console.log(activeFooter);
    console.log(navLink);
    redirect(activeFooter.path + '/' + navLink.path);
  };
  return (
    <>
      {links.map((navLink, index) => (
        <Link
          onClick={() => changePage(navLink)}
          key={'pageLink_' + index}
          className={`text color-dark flex-grow-1 flex-shrink-0 text-center ${styles.pageTab} ${navLink.path === searchedItem.path && styles.activeTab}`}
          to={activeFooter.path + navLink.path}
        >
          <span className="text-16">{navLink.text}</span>
        </Link>
      ))}
    </>
  );
};

export const StrapiPageNavigation: React.FC<Props> = ({ links, bgColor }) => {
  return (
    <div className={`${styles.navigationWrapper} container-fluid px-0 `} style={{ backgroundColor: bgColor }}>
      <div className={`container-md`}>
        <div className="row">
          <div className={`col-12 d-flex flex-nowrap ${styles.tabsWrapper}`}>
            <PageNav links={links} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrapiPageNavigation;
